module.exports = __webpack_public_path__ + "img/icon_youtube_w.34c11b0f.svg";